module.exports = __webpack_public_path__ + "static/img/room_windows.4e91ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/param/room_windows.png
// module id = MS+r
// module chunks = 0